import { ArrowRight, CheckCircle2, FileDown, MessageCircle, X } from "lucide-react";
import { API, trackWhatsApp } from "../../lib/api";
import { waLink } from "../../lib/brand";
import { useProducts } from "../../hooks/useProducts";

export function SpecModal({ product: p, close, onQuote, onSwitch }) {
  const products = useProducts();
  return (
    <div className="modal-backdrop" role="presentation" onClick={(e) => e.target === e.currentTarget && close()}>
      <div className="modal spec-modal" data-testid="spec-modal">
        <button className="icon-btn modal-close" onClick={close} data-testid="spec-modal-close" aria-label="Close"><X /></button>
        <div className="spec-media"><img src={p.image} alt={p.name} /><span className="glass-chip">MOQ · {p.moq}</span></div>
        <div className="spec-body">
          <p className="eyebrow">Technical specifications · {p.category}</p>
          {products.length > 0 && (
            <select className="spec-switch" value={p.slug} onChange={(e) => onSwitch(products.find((x) => x.slug === e.target.value))} data-testid="spec-product-switch">
              {products.map((x) => <option key={x.slug} value={x.slug}>{x.name}</option>)}
            </select>
          )}
          <h2 data-testid="spec-modal-title">{p.name}</h2>
          <p className="modal-intro">{p.description}</p>
          <table className="spec-table" data-testid="spec-table"><tbody>{Object.entries(p.specs).map(([k, v]) => <tr key={k}><th>{k}</th><td>{v}</td></tr>)}</tbody></table>
          <ul className="spec-highlights">{p.highlights.map((h) => <li key={h}><CheckCircle2 size={14} /> {h}</li>)}</ul>
          <div className="spec-actions">
            <button className="button button-orange" onClick={() => onQuote(p)} data-testid="spec-bulk-quote-button">Request bulk quote <ArrowRight size={15} /></button>
            <a className="button button-navy" href={`${API}/products/${p.slug}/spec-sheet.pdf`} data-testid="spec-download-button"><FileDown size={15} /> PDF spec sheet</a>
            <a className="button button-ghost" href={waLink(`Hello ML FAB Enterprises, I need details for ${p.name}.`)} target="_blank" rel="noreferrer" onClick={() => trackWhatsApp("spec-modal", p.name)} data-testid="spec-whatsapp-button"><MessageCircle size={15} /> WhatsApp</a>
          </div>
        </div>
      </div>
    </div>
  );
}
